export default __webpack_public_path__ + "static/media/How 1-1.1244b1b1.svg";